import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import { IIconType } from "@/icons";
import { Icon } from "@/components/Icon";

interface ISecurityItem {
  id: number;
  title: string;
  text: string;
  icon: IIconType;
}

export const EnterpriseGradeSecurityItem: React.FC<
  Omit<ISecurityItem, "id">
> = ({ title, text, icon }) => {
  const { css } = useFela();
  const { bp, colors } = useTheme();

  const border = "1px solid #e5eaf4";

  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexBasis: "50%",
        padding: "30px 40px",
        [bp.FROM_DESKTOP]: {
          padding: "60px 80px",
        },
        nested: {
          ":first-child": {
            borderBottom: border,
            [bp.FROM_DESKTOP]: {
              borderRight: border,
            },
          },
          ":nth-child(2)": {
            borderBottom: border,
            borderTop: border,
            [bp.FROM_DESKTOP]: {
              borderLeft: border,
              borderTop: "none",
            },
          },
          ":nth-child(3)": {
            borderBottom: border,
            borderTop: border,
            [bp.FROM_DESKTOP]: {
              borderRight: border,
              borderBottom: "none",
            },
          },
          ":last-child": {
            borderTop: border,
            [bp.FROM_DESKTOP]: {
              borderLeft: border,
            },
          },
        },
      })}
    >
      <Icon iconType={icon} />
      <Heading
        as="h3"
        customStyle={{
          margin: "24px 0 16px",
          textAlign: "center",
        }}
      >
        {title}
      </Heading>
      <p
        className={css({
          textAlign: "center",
          color: colors.GRAY,
        })}
      >
        {text}
      </p>
    </div>
  );
};
